<template>
  <section class="section" v-if="domain">
    <div class="container">
      <ViewSelector :view="view" @change="setView($event)">
        <Title :skipMarginBottom="true">
          Groups
          <Plus @click="showAdd = true"></Plus>
        </Title>
      </ViewSelector>

      <SearchBar
        v-model="tempFilter"
        :id="searchId"
        :selectOnSubmit="true"
        :loading="searching"
        :focus="true"
        @submit="search($event)"
      ></SearchBar>

      <Tips
        v-if="firstLoadDone && $store.state.group.groups.length !== 0"
        path="groups"
        xKey="dismissedTips"
        property="rightClick"
        :rightClickIconVisible="true"
        >Right-click on a group name to open the context menu
      </Tips>

      <p v-if="firstLoadDone && $store.state.group.groups.length === 0">
        <i>No groups.</i>
      </p>

      <div v-if="$store.state.group.groups.length !== 0">
        <View1
          v-if="view == 1"
          :items="filtered"
          @order="dispatchGroupOrder($event)"
          @save="rename($event.groupItem, $event.text)"
          @cancel="toggleRename($event)"
          @menu="$refs.menu.open($event.e, $event.groupItem)"
        ></View1>

        <View2
          v-if="view == 2"
          :items="filtered"
          @order="dispatchGroupOrder($event)"
          @save="rename($event.groupItem, $event.text)"
          @cancel="toggleRename($event)"
          @menu="$refs.menu.open($event.e, $event.groupItem)"
        ></View2>
        <Paging
          v-show="!searching && firstLoadDone"
          :items="paging.pages"
          :selected="paging.page"
          :size="paging.max"
          @change="setPage($event)"
          @size="setPageMax($event)"
          :hasOptions="true"
          autosave="groups"
        ></Paging>
      </div>
    </div>

    <vue-context ref="menu">
      <template v-if="domain && child.data" slot-scope="child">
        <li v-if="domain.permission && domain.permission < 8">
          <a>
            <i>Too low permissions</i>
          </a>
        </li>

        <li v-if="!domain.permission || domain.permission >= 16">
          <a @click.prevent="toggleRename(child.data)">Rename</a>
        </li>

        <li v-if="domain.permission >= 16 || !domain.permission">
          <a
            @click.prevent="
              selected = child.data;
              showAdd = true;
            "
            >Edit computers</a
          >
        </li>

        <Wol
          v-if="
            (!domain.permission || domain.permission >= 8) &&
              child.data.computers
          "
          :computers="child.data.computers"
          >Wake computers</Wol
        >
        <li v-if="!domain.permission || domain.permission >= 64">
          <a
            @click.prevent="
              showDelete = !showDelete;
              selected = child.data;
            "
            >Delete</a
          >
        </li>
      </template>
    </vue-context>

    <Add
      v-if="showAdd"
      v-model="showAdd"
      :domain="domain"
      title="Group"
      :groupItem="selected"
      @hide="selected = null"
      @save="saveAdd($event)"
    ></Add>

    <GroupConfirm
      v-if="selected && showDelete"
      v-model="showDelete"
      :groupItem="selected"
      @hide="selected = null"
      @confirmed="_delete(selected)"
    ></GroupConfirm>
  </section>
</template>
<script>
import { postApi } from "@/utils/http";
import {
  cancelGroupPackageSchedule,
  requestGroupPackagesUpdate,
} from "@/utils/socket";

import { parseAndRound } from "@/utils/string";
import { fromNow } from "@/utils/date";
import { getId } from "@/utils/document";
import { dispatchGroupOrder } from "@/utils/order";
import { sendPackages } from "@/utils/socket";

import { getStartIndex, getNumbers } from "@/utils/paging";

export default {
  components: {
    Tips: () => import("@/components/main/Tips.vue"),
    Title: () => import("@/components/singles/Title.vue"),
    VueContext: () => import("vue-context"),
    GroupConfirm: () => import("@/components/main/group/Delete.vue"),
    Wol: () => import("@/components/main/context_menu/Wol.vue"),
    Add: () => import("@/components/main/group/Add.vue"),
    Plus: () => import("@/components/main/Plus.vue"),
    SearchBar: () => import("@/components/main/SearchBar.vue"),
    View1: () => import("@/components/main/group/View1.vue"),
    View2: () => import("@/components/main/group/View2.vue"),
    ViewSelector: () => import("@/components/main/ViewSelector.vue"),
    Paging: () => import("@/components/main/paging/Nav.vue"),
  },
  props: { domain: Object },
  computed: {
    view() {
      return this.$store.state.settings.user.groups &&
        this.$store.state.settings.user.groups.view
        ? this.$store.state.settings.user.groups.view
        : 1;
    },
    filtered() {
      let items = this.$store.state.group.groups;

      if (this.filter && this.filter !== "") {
        items = items.filter(
          (x) => x.group.name.toLowerCase().indexOf(this.filter) !== -1
        );
      }

      this.setPages(items);

      if (this.paging.max === -1) return items;
      else {
        return items.slice(
          this.paging.start,
          this.paging.page * this.paging.max
        );
      }
    },
    parseAndRound() {
      return (str) => {
        return parseAndRound(str);
      };
    },

    fromNow() {
      return (date) => {
        return fromNow(date);
      };
    },
  },
  data() {
    return {
      selected: null,
      showDelete: false,
      showAdd: false,
      saving: false,
      firstLoadDone: false,
      searching: false,
      tempFilter: "",
      filter: "",
      searchId: getId(),
      paging: {
        page: 1,
        max: 15,
        start: 0,
        pages: [],
      },
    };
  },
  async created() {
    try {
      await this.$store.dispatch("group/fetch", {
        domainUID: this.$route.params.domainUID,
      });

      await this.$store.dispatch("settings/getUserSetting", {
        path: "groups",
        key: "paging",
      });

      const paging = this.$store.state.settings.user.groups?.paging;
      if (paging && paging.max) this.paging.max = paging.max;

      this.firstLoadDone = true;
    } catch (err) {
      console.log(err);
      this.$helpers.notify("Error", "Could not get groups.", "danger", 5000);
    }
  },
  methods: {
    setPageMax(size) {
      this.paging.max = size;

      this.setPage(1);
      this.setPages(this.$store.state.group.groups);
    },
    setPages(items) {
      this.paging.pages = getNumbers(items, this.paging.max);
    },
    setPage(page) {
      this.paging.start = getStartIndex(page, this.paging.max);
      this.paging.page = page;
    },
    setView(view) {
      this.$store.dispatch("settings/setUser", {
        path: "groups",
        key: "view",
        value: view,
      });
    },
    dispatchGroupOrder: dispatchGroupOrder,
    search(searchStr) {
      this.searching = true;

      searchStr = searchStr.trim().toLowerCase();
      this.filter = searchStr;

      this.searching = false;
    },
    async saveAdd(data) {
      if (this.selected) {
        if (data.added.length !== 0 || data.removed.length !== 0) {
          await this.save(data);
        } else {
          this.$helpers.notify("No changes", "Nothing to save.", "primary");
        }
      } else await this.add(data);

      this.showAdd = false;
      this.selected = null;
    },
    async save(data) {
      if (data.removed.length !== 0)
        cancelGroupPackageSchedule(this.selected.group.uid, data.removed);

      await this.$store.dispatch("group/edit", {
        domainUID: this.$route.params.domainUID,
        computerUIDs: data.all,
        groupUID: this.selected.group.uid,
      });

      if (data.added && data.added.length > 0)
        requestGroupPackagesUpdate(this.selected.group.uid, data.added);
    },
    async add(data) {
      const result = await this.$store.dispatch("group/add", {
        domainUID: this.$route.params.domainUID,
        computerUIDs: data.added,
        name: data.name,
      });

      if (result && result.group && data.packages && data.packages.length > 0) {
        if (!sendPackages(data.packages, [], result.group.uid)) {
          this.$helpers.notify(
            "Error",
            "Could not copy the packages, not connected to the server.",
            "danger",
            5000
          );
        }
      }
    },
    toggleRename(groupItem) {
      this.$store.commit("group/edit", {
        g: groupItem.group,
        obj: { edit: !groupItem.group.edit },
      });
    },
    async _delete(groupItem) {
      const cancelScheduleResult = cancelGroupPackageSchedule(
        groupItem.group.uid,
        groupItem.computers.map((x) => x.uid)
      );

      if (cancelScheduleResult) {
        await postApi("delete/group", {
          uid: groupItem.group.uid,
          domainUID: this.domain.uid,
        });

        this.$store.commit("group/remove", groupItem.group);
      } else {
        this.$helpers.notify(
          "Error",
          "Could not remove schedules, not connected to the server.",
          "danger",
          5000
        );
      }

      this.showDelete = false;
      this.selected = null;
    },

    async rename(groupItem, text) {
      this.saving = true;
      text = text.trim();

      await postApi("set/groupName", {
        groupUID: groupItem.group.uid,
        name: text,
        domainUID: this.domain.uid,
      });

      this.$store.commit("group/edit", {
        g: groupItem.group,
        obj: { name: text, edit: false },
      });

      this.saving = false;
    },
  },
};
</script>
